import styled from '@emotion/styled';
import { motion } from 'framer-motion';

// Styled Components
const SelectorWrapper = styled.div`
  height: 44px;
  border-radius: 0 4px 4px 0;
  border: 1px solid var(--border1);
  border-left: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120px;
  background: var(--border1); // Dark background
  position: relative;
  cursor: pointer;
  padding: 2px; // Reduced padding
`;

const Option = styled.div`
  flex: 1;
  text-align: center;
  z-index: 2;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  padding: 5px;
  color: var(--prim1);
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

const Slider = styled(motion.div)`
  position: absolute;
  height: calc(100% - 4px); // Adjusted to match reduced padding
  width: calc(50% - 4px); // Adjusted width
  background: white;
  border-radius: 4px;
  top: 2px; // Align within reduced padding
  left: 2px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15); // Subtle shadow
`;

interface IOptionSelectorProps {
  value: 'flat' | 'percent';
  onChange(newVal: 'flat' | 'percent'): void;
}

const OptionSelector = ({ value, onChange }: IOptionSelectorProps) => {
  return (
    <SelectorWrapper onClick={() => onChange(value === 'flat' ? 'percent' : 'flat')}>
      {/* Sliding Background */}
      <Slider
        layout={false} // Prevents Framer Motion from animating position changes
        transition={{ type: 'spring', stiffness: 400, damping: 25 }}
        animate={{ left: value === 'flat' ? '2px' : 'calc(50% + 2px)' }}
        style={{ top: '2px' }}
      />
      {/* Options */}
      <Option className="center">FLAT</Option>
      <Option className="center">%</Option>
    </SelectorWrapper>
  );
};

export default OptionSelector;
